<template>
  <div class="widget--line_chart">
    <canvas ref="chart"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js";

export default {
  props: {
    rows: {
      type: Array,
      default() {
        return [];
      }
    },
    yaxis: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  mounted() {
    this.render();
  },
  methods: {
    async render() {
        let first_ts = JSON.parse(this.rows[0].request_data).meterValue[0]["timestamp"];
        this.rows.map((data,i)=>{
          let json = JSON.parse(data.request_data);
          let meterValue = json.meterValue[0];
          let sampledValue = meterValue["sampledValue"];
    
          let ts = meterValue.timestamp;
          let e = sampledValue.find(val=>val.unit=="Wh")?.value;
          let v = sampledValue.find(val=>val.unit=="V")?.value;
          let a = sampledValue.find(val=>val.unit=="A")?.value;
          // handle time
          
          let first_ets = this.$moment(first_ts).unix();
          let ets = this.$moment(ts).unix();
          let time_diff = ets - first_ets;
    
          // this.dataset.times.push(Math.floor(time_diff));
          let timeFormat = "HH:mm";
          console.log(i)
          if(i == 0){
            timeFormat = "MM-DD HH:mm";
          }
          this.dataset.times.push(this.$moment(data.cre_dttm).format(timeFormat));
          this.dataset.dates.push(this.$moment(data.cre_dttm).format("YYYY-MM-DD HH:mm:ss"));
          // this.dataset.times.push(data.cre_dttm);
    
          this.dataset.energies.push(e/1000);
          this.dataset.voltages.push(v);
          this.dataset.amperes.push(a);
        });

      this.dataset.dates.sort((a,b)=>{
        return this.$moment(a).unix() - this.$moment(b).unix();
      });
  
      var ctx = this.$refs.chart;
      ctx.height = 80;
      
      this.chart = new Chart(ctx, this.chartConfig);
      this.chart.render;
    },
  },
  computed: {
    chartConfig() {
      let vm = this;
      let general_config = {
        fill: false,
        borderWidth: 2,
        lineTension: 0,
      }
      return {
          type: 'line',
          data: {
              labels: this.yaxis && this.yaxis.length>0 ? this.yaxis : this.dataset.times,
              datasets: [
                {
                  ...general_config,
                  label: 'kWh',
                  yAxisID: 'A',
                  data: this.dataset.energies,
                  borderColor: "rgb(98, 252, 3)",
                },
                {
                  ...general_config,
                  label: 'A',
                  yAxisID: 'B',
                  data: this.dataset.amperes,
                  borderColor: "rgb(255, 0, 81)",
                },
                {
                  ...general_config,
                  label: 'V',
                  yAxisID: 'C',
                  data: this.dataset.voltages,
                  borderColor: "rgb(252, 186, 3)",
                }
              ]
          },
          options: {
            stacked: false,
            scales: {
              xAxes: [
                {
                  scaleLabel: {
                    display: true,
                    labelString: this.$t("unit.sec")
                  }
                }
              ],
              yAxes: [{
                id: 'A',
                // type: 'linear',
                position: 'left',
                ticks: {
                  fontColor: "rgb(98, 252, 3)",
                }
              }, {
                id: 'B',
                // type: 'linear',
                position: 'right',
                ticks: {
                  fontColor: "rgb(255, 0, 81)",
                }
              },
              {
                id: 'C',
                // type: 'linear',
                position: 'right',
                ticks: {
                  fontColor: "rgb(252, 186, 3)",
                }
              }]
            },
            tooltips: {
              callbacks: {
                beforeLabel: function(tooltipItem, data) {
                  let index = tooltipItem.index;
                  console.log(tooltipItem);
                  return vm.dataset.dates[index];
                }
              }
            }
          }
      };
    }
  },
  data() {
    return {
      chart: {},
      dataset: {
        times: [],
        dates: [],
        energies: [],
        voltages: [],
        amperes: []
      }
      
    }
  }
}
</script>

<style lang="scss">
.widget--line_chart{
  #chart{
  }
}
</style>